import type { LoaderFunction, LoaderFunctionArgs } from 'react-router-dom';
import { apiListGetUserByToken } from "../../components/ui_components/ApiList";
import { redirect } from "react-router-dom";

/**
 * Funzione helper per verificare se l'utente e admin
 * @returns {Promise<boolean>} true se l'utente e admin, false altrimenti
 */
async function checkIsAdmin(): Promise<boolean> {
    try {
        const user = await apiListGetUserByToken();

        // Se l'utente non esiste o non ha username, non e autenticato
        if (!user || !user.username) {
            return false;
        }

        // Verifica se e admin
        return !!user.is_admin;
    } catch (error) {
        console.error('Errore durante il controllo admin:', error);
        return false;
    }
}

/**
 * Loader per proteggere le route admin
 * Verifica che l'utente sia autenticato e sia admin
 * Se non e admin, reindirizza alla homepage
 *
 * Questo loader puo essere combinato con altri loader usando combineLoaders
 */
export const AdminRouteProtection: LoaderFunction = async () => {
    const isAdmin = await checkIsAdmin();

    if (!isAdmin) {
        return redirect('/');
    }

    // Se e admin, restituisce null per permettere il rendering della route
    return null;
};

/**
 * Combina un loader esistente con il controllo admin
 * @param loaderFunction - Il loader da eseguire dopo il controllo admin
 * @returns Un loader combinato che verifica admin e poi esegue il loader originale
 */
export function combineAdminLoader(loaderFunction?: LoaderFunction): LoaderFunction {
    return async (args: LoaderFunctionArgs) => {
        const isAdmin = await checkIsAdmin();

        if (!isAdmin) {
            return redirect('/');
        }

        // Se e admin, esegue il loader originale
        if (loaderFunction) {
            return await loaderFunction(args);
        }

        return null;
    };
}
